<div class="mt-5 flex flex-column">
  <div class="text-lg-semibold text-gray-900">Svi klijenti</div>

  <div class="mt-3 flex flex-column lg:flex-row lg:align-items-center justify-content-between gap-3">
    <p-tabs class="transparent" [value]="0" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">
          <div class="flex align-items-center gap-2">
            <app-building-05
              [stroke]="activeTab === 0 ? '#181D27' : '#7E838F'"
              width="16px"
              height="16px"
            ></app-building-05>
            <span class="text-sm-semibold">Pravna lica</span>
          </div>
        </p-tab>
        <p-tab [value]="1">
          <div class="flex align-items-center gap-2">
            <app-user-circle
              [stroke]="activeTab === 1 ? '#181D27' : '#7E838F'"
              width="16px"
              height="16px"
            ></app-user-circle>
            <span class="text-sm-semibold">Fizička lica</span>
          </div>
        </p-tab>
      </p-tablist>
    </p-tabs>

    <div class="search-input">
      <app-text-input
        [hasIcon]="true"
        ctrlPlaceholder="Pretraga"
        formCtrlClass="table-search-input"
        shortcutHint="⌘K"
        [formCtrl]="searchFormCtrl | formControl"
      >
        <app-search stroke="#ADB0B8"></app-search>
      </app-text-input>
    </div>
  </div>

  <app-data-table
    class="mt-3-5 clients-table"
    [value]="clients"
    [first]="first"
    [rows]="paginatedData.pageSize!"
    [totalRecords]="paginatedData.totalCount!"
    [isLoading]="isLoading"
    [tableStyleClass]="clients.length === 0 ? 'hide-header' : ''"
    [hasPreviousPage]="!!paginatedData.hasPreviousPage"
    [hasNextPage]="!!paginatedData.hasNextPage"
    (lazyLoad)="loadLazy($event)"
    (prevPage)="prev()"
    (nextPage)="next()"
  >
    <!-- HEADER -->
    <ng-template #tableHeader>
      <tr>
        <th>
          <div class="text-xs-semibold text-gray-400">
            {{ activeTab === 0 ? 'NAZIV KOMPANIJE' : 'IME I PREZIME' }}
          </div>
        </th>
        <th class="hours-col">
          <div class="text-xs-semibold text-gray-400">
            {{ activeTab === 0 ? 'PREOSTALO SATI' : 'AKTIVNI PAKET' }}
          </div>
        </th>
        <th>
          <div class="text-xs-semibold text-gray-400">PREDSTOJEĆI</div>
        </th>
        <th>
          <div class="text-xs-semibold text-gray-400">UKUPNO</div>
        </th>
      </tr>
    </ng-template>

    <!-- BODY -->
    <ng-template #tableBody let-client>
      <tr class="cursor-pointer" (click)="routeToClientDetails(client.id)">
        <!-- Name + icon -->
        <td>
          <div class="flex align-items-center gap-3">
            <div class="client-icon">
              @if (client.isCompany) {
                <app-building-05 stroke="#ADB0B8" width="20px" height="18px"></app-building-05>
              } @else {
                <app-user-circle stroke="#ADB0B8" width="20px" height="20px"></app-user-circle>
              }
            </div>
            <span class="text-sm-medium text-gray-900">{{ client.name }}</span>
          </div>
        </td>

        <!-- Aktivni paket (Individualni) / Remaining hours with progress bar (Poslovni) -->
        <td>
          @if (activeTab === 0) {
            <div class="hours-progress flex align-items-center">
              <div class="flex flex-1 align-items-center gap-3">
                <div class="progress-bar-track">
                  <div
                    class="progress-bar-fill"
                    [class.progress-bar-fill--red]="isBarRed(client)"
                    [style.width.%]="getBarPercent(client)"
                  ></div>
                </div>
                <span class="text-sm-medium text-gray-900">{{ client.remainingHours ?? 0 }}</span>
              </div>
              <span class="text-sm-medium text-gray-500 hours-text">/ {{ client.totalHours ?? 0 }}</span>
            </div>
          } @else {
            <span class="text-sm-medium text-gray-900">
              {{ client.totalHours ? client.totalHours + 'h termin' : '-' }}
            </span>
          }
        </td>

        <!-- Upcoming hours -->
        <td>
          <span class="flex gap-1 text-sm-medium">
            <span class="text-gray-900">{{ client.upcomingHours ?? 0 }}</span>
            <span class="text-gray-500">h</span>
          </span>
        </td>

        <!-- All-time hours -->
        <td>
          <span class="flex gap-1 text-sm-medium">
            <span class="text-gray-900">{{ client.allTimeHours ?? 0 }}</span>
            <span class="text-gray-500">h</span>
          </span>
        </td>
      </tr>
    </ng-template>

    <!-- EMPTY STATE -->
    <ng-template #tableEmpty>
      <tr>
        <td colspan="4">
          <div class="flex justify-content-center align-items-center text-gray-900 text-lg-semibold py-5">
            Nema klijenata
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- LOADING SKELETON -->
    <ng-template #tableLoading>
      @for (row of [1, 2, 3, 4, 5]; track row) {
        <tr>
          <td>
            <div class="flex align-items-center gap-2">
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
              <p-skeleton width="7rem"></p-skeleton>
            </div>
          </td>
          <td>
            <div class="flex align-items-center gap-2">
              <p-skeleton width="8rem" height="0.5rem"></p-skeleton>
              <p-skeleton width="4rem"></p-skeleton>
            </div>
          </td>
          <td><p-skeleton width="3rem"></p-skeleton></td>
          <td><p-skeleton width="3rem"></p-skeleton></td>
        </tr>
      }
    </ng-template>
  </app-data-table>
</div>
